import * as React from 'react';
import { Button, CircularProgress, Typography, Stack, ButtonGroup } from '@mui/material';
import { useEffect } from 'react';
import { checkPaymentStatus, getAllPayments, PostResendLink, postSecondPaymentLink } from 'API/AgentOnboarding/api';
import { useState } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useNavigate } from 'react-router';
import SendIcon from "../../../../assets/images/icons/send_link.png"
import './FixedTable.css';
import ResendDialog from './ResendDialog';

export default function PaymentTable(props) {
  const [page, setPage] = React.useState(0);
  // const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [AlertType, setAlertType] = useState('success');
  const [AlertOpen, setAlertOpen] = useState(false);
  const [AlertMessage, setAlertMessage] = useState(null);
  const Nav = useNavigate();
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getAllPayments(newPage + 1, props.filter, setData, setIsLoading);

  };

  const [ResendId, setResendId] = useState(null)
  const [OpenResend, setOpenResend] = useState(false)


  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };


  const handleOpenResendDialog = (id) => {
    setResendId(id)
    setOpenResend(true)
  }

  const handleCloseResendDialog = () => {
    setOpenResend(false)
  }

  const handleAlertOpen = (message, type) => {
    setAlertMessage(message)
    setAlertType(type)
    setAlertOpen(true)
  }


  const handlePostResendLink = () => {
    PostResendLink(ResendId, setIsLoading, handleAlertOpen, handleCloseResendDialog)
  }

  //   { id: 1,
  //      total_amount: '10000',
  //      bank_name:'SBI',
  //      mode_of_payment: 'Full payment' ,
  //      sign_on_amount:200,
  //      hardware_amount:3000,
  //      due_amount:4000,
  //      due_date:'12/12/2021',
  //      status:'pending',
  //      resend_link:'resend'
  //     },

  // ];

  const [Data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getAllPayments(page + 1, props.filter, setData, setIsLoading);
  }, []);

  console.log('data', Data);

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  const handleSearch = () => {
    getAllPayments(page + 1, props.filter, setData, setIsLoading);
  };

  const handleClearFilter = () => {
    getAllPayments(
      page + 1,
      {
        name: '',
        bank: '',
        mobile_number: '',
        mode_of_paymnet: '',
        payment_status: ''
      },
      setData,
      setIsLoading
    );
  };

  useEffect(() => {
    if (props.setSearchFunction) {
      props.setSearchFunction(() => handleSearch);
    }
    if (props.setClearFunction) {
      props.setClearFunction(() => handleClearFilter);
    }
  }, [props.setSearchFunction, props.filter]);

  const [StatusLoading, setStatusLoading] = useState(false);
  const [ButtonIndex, setButtonIndex] = useState(0);

  const handleCheckStatus = (params, index) => {
    console.log('params', params);
    setButtonIndex(index);
    checkPaymentStatus(params, setStatusLoading, setAlertMessage, setAlertType, setAlertOpen, getAllPayments, setData, setIsLoading);
  };

  const handleResendPayment = (item) => {
    console.log('part link', item);
    // checkPaymentStatus(params,setStatusLoading,setAlertMessage,setAlertType,setAlertOpen,getAllPayments,setData,setIsLoading)
    postSecondPaymentLink(item, setAlertMessage, setAlertType, setAlertOpen, setIsLoading);
  };

  return (
    <div style={{ width: '100%' }}>
      <ResendDialog open={OpenResend} handleClose={handleCloseResendDialog} isLoading={isLoading} handleSubmit={handlePostResendLink} />
      <Snackbar open={AlertOpen} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} autoHideDuration={6000} onClose={handleAlertClose}>
        <Alert onClose={handleAlertClose} severity={AlertType} variant="filled" sx={{ width: '100%' }}>
          {AlertMessage}
        </Alert>
      </Snackbar>
      {isLoading ? (
        <Stack justifyContent="center" alignItems="center" width="100%">
          <CircularProgress />
          <Typography mt={1} variant="subtitle1" color="grey">
            Loading...
          </Typography>
        </Stack>
      ) : (
        <Paper sx={{ width: '100%' }}>
          
          {Data && Data.data && Data.data.length > 0 ? (
            <TableContainer sx={{ maxHeight: 600, width: '100%' }} className="table-container" component={Paper}>
              <Table  size='small'>
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#F8FAFC !important", color: "#592375", padding: '10px' }}>
                    <TableCell className="fixed-col first-col" sx={{ width: 200, backgroundColor: "#F8FAFC", color: "#592375", paddingBlock: '20px' }}>
                      Agent Name
                    </TableCell>
                    <TableCell className="fixed-col second-col" sx={{ width: 130, backgroundColor: "#F8FAFC", color: "#592375", paddingBlock: '20px' }}>
                      Mobile.No
                    </TableCell>
                    <TableCell className="fixed-col third-col" sx={{ width: 200, backgroundColor: "#F8FAFC", color: "#592375", paddingBlock: '20px' }}>
                      Bank Name
                    </TableCell>
                    <TableCell sx={{ width: 200, color: "#592375", paddingBlock: '20px' }}>Hardware Devices</TableCell>
                    <TableCell sx={{ width: 250, color: "#592375", paddingBlock: '20px' }}>Type of Payment</TableCell>
                    <TableCell sx={{ width: 200, color: "#592375", paddingBlock: '20px' }}>Total Amount</TableCell>
                    <TableCell sx={{ width: 200, color: "#592375", paddingBlock: '20px' }}>Part Amount</TableCell>
                    <TableCell sx={{ width: 200, color: "#592375", paddingBlock: '20px' }}>Due Amount</TableCell>
                    <TableCell sx={{ width: 250, color: "#592375", paddingBlock: '20px' }}>Due Date</TableCell>
                    <TableCell sx={{ width: 200, color: "#592375", paddingBlock: '20px' }}>Installment 1 Status</TableCell>
                    <TableCell sx={{ width: 200, color: "#592375", paddingBlock: '20px' }}>Installment 2 Status</TableCell>
                    <TableCell sx={{ width: 250, color: "#592375", paddingBlock: '20px' }}>View Kiosk</TableCell>
                    <TableCell sx={{ width: 130, color: "#592375", paddingBlock: '20px' }}>Next installment</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Data && Data.data &&
                    Data.data.map((row, index) => {
                      return (
                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 }, backgroundColor: index % 2 === 0 ? "#F5F5F5" : "#fff" }}  role="checkbox" tabIndex={-1} key={row.code}>
                          <TableCell sx={{ backgroundColor: index % 2 === 0 ? "#F5F5F5 !important" : "#fff !important" }} className="fixed-col first-col">
                            {row.customer_details ? row.customer_details.customer_name : '-'}
                          </TableCell>
                          <TableCell sx={{ backgroundColor: index % 2 === 0 ? "#F5F5F5 !important" : "#fff !important" }} className="fixed-col second-col">
                            {row.customer_details ? row.customer_details.customer_mobile : '-'}
                          </TableCell>
                          <TableCell sx={{ backgroundColor: index % 2 === 0 ? "#F5F5F5 !important" : "#fff !important" }} className="fixed-col third-col">
                            {row.product_details && row.product_details[0] !== null ? row.product_details[0].display_name : '-'}
                          </TableCell>
                          <TableCell sx={{ alignItems: 'center', backgroundColor: index % 2 === 0 ? "#F5F5F5" : "#fff" }}>{row.device_id?.length}</TableCell>
                          <TableCell >
                            {row.payment_details?row.payment_details.installment_1 && row.payment_details.installment_1.payment_type === 'full_payment'
                              ? 'Full Payment'
                              : row.payment_details.installment_1.payment_type === 'part_payment'
                                ? 'Part Payment'
                                : '-':"N/A"}
                          </TableCell>
                          <TableCell>
                            {row.payment_details?parseFloat(row.payment_details?row.payment_details.installment_1 ? row.payment_details.installment_1.total_amount : '':""):"0"}
                          </TableCell>
                          <TableCell>
                            {row.payment_details?row.payment_details.installment_1 && row.payment_details.installment_1.part_amount
                              ? parseFloat(
                                row.payment_details.installment_1 && row.payment_details.installment_1.part_amount
                                  ? row.payment_details.installment_1.part_amount
                                  : '-'
                              )
                              : '-':""}
                          </TableCell>
                          <TableCell>
                            {row.payment_details&&row.payment_details.installment_1.balance_amount ? row.payment_details.installment_1.balance_amount : '-'}
                          </TableCell>
                          <TableCell>
                            {row.payment_details&&row.payment_details.installment_1.due_date ? row.payment_details.installment_1.due_date : '-'}
                          </TableCell>
                          <TableCell>
                            <Stack direction="row" gap={1} alignItems="center">
                              {row.payment_details&&row.payment_details.installment_1.payment_status === 'successful' ? (
                                <Button sx={{ borderRadius: '8px' }} variant="contained" color="success">
                                  Success
                                </Button>
                              ) : row.payment_details&&row.payment_details.installment_1.payment_status === 'aborted' ? (
                                <Button sx={{ borderRadius: '8px' }} variant="contained" color="error" onClick={() => handleCheckStatus(row, index)}>
                                  Aborted
                                </Button>
                              ) : (
                                <ButtonGroup sx={{borderRadius:'8px'}} size='small' color='warning' variant="contained" aria-label="Basic button group">
                                  <Button
                                    disabled={index === ButtonIndex ? StatusLoading : row.payment_details&&row.payment_details.installment_1.invoice_id?false:true}
                                    onClick={() => handleCheckStatus(row, index)}
                                    sx={{borderRadius:'8px'}}
                                  >
                                    Check
                                  </Button>

                                  {row.payment_details&&row.payment_details.installment_1.payment_status !== 'successful' && (
                                    <Button
                                      sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        minWidth: '40px', // Keeps it from being too small
                                        height: '40px',    // Make it a square button
                                        padding: 0,
                                        borderRadius:'8px'
                                      }}
                                      onClick={() => handleOpenResendDialog(row._id)}
                                      disabled={row.payment_details&&row.payment_details.installment_1.url?false:true}
                                    >
                                      <img
                                        src={SendIcon}
                                        alt="Send Icon"
                                        style={{ width: '20px', height: '20px' }}
                                      />
                                    </Button>
                                  )}
                                </ButtonGroup>

                              )}



                            </Stack>
                          </TableCell>
                          <TableCell>
                            <Stack direction="row">
                              {row.payment_details&&row.payment_details.installment_2 ? (
                                row.payment_details.installment_2.payment_status === 'successful' ? (
                                  <Button sx={{ borderRadius: '10px' }} variant="contained" color="success">
                                    Success
                                  </Button>
                                ) : row.payment_details.installment_2.payment_status === 'aborted' ? (
                                  <Button sx={{ borderRadius: '10px' }} variant="contained" color="error" onClick={() => handleCheckStatus(row, index)}>
                                    Aborted
                                  </Button>
                                ) : (
                                <ButtonGroup sx={{borderRadius:'8px'}} size='small' color='warning' variant="contained" aria-label="Basic button group">
                                  <Button
                                    disabled={index === ButtonIndex ? StatusLoading : row.payment_details&&row.payment_details.installment_2&&row.payment_details.installment_2.invoice_id?false:true}
                                    onClick={() => handleCheckStatus(row, index)}
                                  >
                                    Check
                                  </Button>

                                  {
                                row.payment_details&&row.payment_details.installment_2 && row.payment_details.installment_2 && row.payment_details.installment_2.payment_status !== 'successful' ?
                                  <Button
                                  variant='contained'
                                  disabled={row.payment_details&&row.payment_details.installment_2.url?false:true}
                                  sx={{
                                    display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        minWidth: '40px', // Keeps it from being too small
                                        height: '40px',    // Make it a square button
                                        padding: 0,
                                        borderRadius:'8px' // Makes it circular (optional)
                                  }} onClick={() => handleOpenResendDialog(row._id)}><img style={{ width: '20px', height: '20px' }} src={SendIcon} alt="icon" /></Button>
                                  :
                                  null
                              }
                                </ButtonGroup>
                                )
                              ) : (
                                '-'
                              )}


                            </Stack>
                          </TableCell>
                          <TableCell>
                            {
                              // row.payment_details.installment_1.payment_status === 'successful' &&
                              !row.kiosk_details_entered &&
                                row.user_type !== 'Self Onboarding' ? (
                                <Button
                                  variant="contained"
                                  color="secondary"
                                  onClick={() =>
                                    Nav('/Admin/AgentKiosk', {
                                      state: {
                                        ID: row._id,
                                        product_id: row.product_id,
                                        email: row.customer_details.customer_email,
                                        mobile: row.customer_details.customer_mobile,
                                        pincode: row.pincode,
                                        bank_name: row.product_details[0].display_name
                                      }
                                    })
                                  }
                                  sx={{ borderRadius: '8px' }}
                                >
                                  Fill Kiosk
                                </Button>
                              ) :
                                // row.payment_details.installment_1.payment_status === 'successful' &&
                                (row.kiosk_details_entered || row.user_type === 'Self Onboarding') ? (
                                  <Button sx={{ borderRadius: '8px' }} variant="outlined" color="success">
                                    kiosk filled
                                  </Button>
                                ) : (
                                  <Button variant="contained" color="warning">
                                    pending
                                  </Button>
                                )}
                          </TableCell>
                          <TableCell>
                            <Button
                              variant="text"
                              disabled={
                                row.payment_details&&row.payment_details.installment_1.payment_type == 'full_payment'
                                  ? true
                                  : row.payment_details&&row.payment_details.installment_2 || row.payment_details&&row.payment_details.installment_1.payment_status !== 'successful'
                                    ? true
                                    : false
                              }
                              onClick={() => handleResendPayment(row)}
                            >
                              {row.payment_details&&row.payment_details.installment_2 ? 'Link Generated' : 'Request'}
                            </Button>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Stack justifyContent="center" alignItems="center">
              <Typography>{isLoading ? 'Loading' : 'No record found'}</Typography>
            </Stack>
          )}

          <TablePagination
            sx={{ width: '100%' }}
            rowsPerPageOptions={[10]}
            component="div"
            count={Data && Data.total_count}
            rowsPerPage={Data && Data.per_page}
            page={page}

            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      )}
    </div>
  );
}
